/* eslint-disable max-lines-per-function */
import React from "react";
import FormControl from "@mui/material/FormControl";
import FormLabel from "@mui/material/FormLabel";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import Radio from "@mui/material/Radio";

type RadioOption = {
  label: React.ReactNode;
  value: string | boolean;
  disabled?: boolean;
};

type RadioGroupBasicProps = {
  name: string;
  label?: React.ReactNode;
  options: RadioOption[];
  row?: boolean;
  defaultValue?: string | boolean;
  value?: string | boolean;
  // eslint-disable-next-line max-len
  onChangeAction?: (selected: { name: string; value: string | boolean; label?: React.ReactNode }) => void;
  formData?: any;
  style?: React.CSSProperties;
};

export const RadioGroupBasic: React.FC<RadioGroupBasicProps> = ({
  name,
  label,
  options,
  row,
  defaultValue,
  value,
  onChangeAction,
  style,
}) => {
  const handleChange = (_event: React.ChangeEvent<HTMLInputElement>, selectedValue: string) => {
    if (onChangeAction) {
      const selected = options.find((option) => String(option.value) === selectedValue);
      onChangeAction({
        name,
        value: selected ? selected.value : selectedValue,
        label: selected?.label,
      });
    }
  };

  const groupValueProps: Record<string, string> = {};
  if (typeof value === "undefined") {
    if (typeof defaultValue !== "undefined") {
      groupValueProps.defaultValue = String(defaultValue);
    }
  } else {
    groupValueProps.value = String(value);
  }
  return (
    <FormControl style={style}>
      {label ? <FormLabel focused={false}>{label}</FormLabel> : null}
      <RadioGroup
        row={row}
        name={name}
        {...groupValueProps}
        onChange={handleChange}
      >
        {options.map((opt, idx) => (
          <FormControlLabel
            key={idx}
            control={
              <Radio
                slotProps={{
                  input: {
                    id: `${name}-${typeof opt.label === "string" ? opt.label : String(opt.value)}`,
                  },
                }}
              />
            }
            label={opt.label}
            value={String(opt.value)}
            disabled={opt.disabled}
          />
        ))}
      </RadioGroup>
    </FormControl>
  );
};

export default RadioGroupBasic;

